import React from 'react';
import { IconQR } from '../icon/QR';
import { IconAllInOne } from '../icon/AllInOne';
import { IconSEOSearch } from '../icon/SEOSearch';
import { IconAR } from '../icon/AR';
import { IconIncreaseSales } from '../icon/IncreaseSales';
import { IconDatabase } from '../icon/Database';
import { IconBox } from '../icon/Box';
import { IconDelivery } from '../icon/Delivery';
import "../icon/IconSize32px.css";
import "../icon/IconSize40px.css";

// Shared feature lists
export const businessContentFeatures = [
  { icon: <IconQR className="icon-size-40px" />, title: 'Dynamic QR Code', description: 'You can use it to access the QR code at any time, without having to install any application.' },
  { icon: <IconAllInOne className="icon-size-40px" />, title: 'Everything in One Place', description: 'Reflect your brand voice by adding your logo, style, images, and other design elements.' },
  { icon: <IconSEOSearch className="icon-size-40px" />, title: 'Get Ranked on Search Engine', description: 'Increase your organic search traffic, from potential customers visiting your site every day.' },
  { icon: <IconAR className="icon-size-40px" />, title: 'Augmented Reality', description: 'Create immersive AR QR Code experiences. Engage your audience on iOS and Android.' },
  { icon: <IconIncreaseSales className="icon-size-40px" />, title: 'Increase Sales', description: 'Increase sales by over 30% - backed by many successful models.' },
  { icon: <IconDatabase className="icon-size-40px" />, title: 'Statistics and Reports', description: 'Seamlessly export and analyze target customer demographics, behaviors, and interests.' },
];

export const addBusinessContentPoints = [
  { icon: <IconBox className="icon-size-32px" />, text: 'Through a simple and smooth user interface, you can explore a wide range of products and services, increasing their chances of achieving the maximum benefit.' },
  { icon: <IconDelivery className="icon-size-32px" />, text: 'Invest in this distinctive experience for the satisfaction of your customers and for them, and to ensure them an unfortunate shopping trip.' },
];
